/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Region
 */
export interface Region {
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    regionId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Region
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    regionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    regionName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    parentRegionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    parentRegionName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Region
     */
    parentRegionEffective?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof Region
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof Region
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Region
     */
    updatedDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Region
     */
    enabled?: boolean | null;
}

export function RegionFromJSON(json: any): Region {
    return RegionFromJSONTyped(json, false);
}

export function RegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Region {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'regionId': !exists(json, 'regionId') ? undefined : json['regionId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
        'regionName': !exists(json, 'regionName') ? undefined : json['regionName'],
        'parentRegionCode': !exists(json, 'parentRegionCode') ? undefined : json['parentRegionCode'],
        'parentRegionName': !exists(json, 'parentRegionName') ? undefined : json['parentRegionName'],
        'parentRegionEffective': !exists(json, 'parentRegionEffective') ? undefined : json['parentRegionEffective'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function RegionToJSON(value?: Region | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'regionId': value.regionId,
        'allowEdit': value.allowEdit,
        'regionCode': value.regionCode,
        'regionName': value.regionName,
        'parentRegionCode': value.parentRegionCode,
        'parentRegionName': value.parentRegionName,
        'parentRegionEffective': value.parentRegionEffective,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
        'enabled': value.enabled,
    };
}


